// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15YH4","textarea":"styles_textarea__C8W-Q"};